import { FC } from 'react';
import { Button } from 'atoms/Button';
import { usePrice } from 'modules/formatter/hooks';
import { IProductSize } from 'commerce/scayle/utils/adapter/types';

export const SizeButton: FC<{
  size: IProductSize;
  className: string;
  selected: boolean;
  disabled: boolean;
  onClick: () => void;
}> = ({ className, size, selected, disabled, onClick }) => {
  const price = usePrice(size.price.withTax, size.price.currencyCode);

  return (
    <Button
      disabled={disabled}
      className={className}
      onClick={onClick}
      color="purple"
      data-state={selected ? 'active' : ''}
    >
      {size.label} ({price?.amount}
      {price?.currency})
    </Button>
  );
};
